import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DocumentTemplateService as ComponentService } from '../document-template.service';
import { DocumentCategoryService } from '../../document-category/document-category.service';
import { AuthService } from 'src/app/services/auth.service';
import { finalize, map } from 'rxjs';
import { NotificationService } from 'src/app/services/notification.service';
import { environment } from 'src/environments/environment';
import { helper } from 'src/environments/helper';
import {
    DocumentTemplate as objectPayload,
    DocumentTemplateAddPayload as objectAddPayload,
    DocumentTemplateEditPayload as objectEditPayload,
    DocumentTemplateForm as objectForm,
} from '../document-template.interface';

import { CerereTypeService } from '../../cerere-type/cerere-type.service';

import { AngularEditorConfig } from '@kolkov/angular-editor';
import { initializeEditor } from 'src/app/utils/storage/editorConfig';
import { RegistreService } from '../../registre/registre.service';
import { conditionalRequiredValidator } from 'src/app/validators/conditional-formating';

@Component({
    selector: 'app-edit-document-template',
    templateUrl: './edit-document-template.component.html',
    styleUrls: ['./edit-document-template.component.scss'],
})
export class EditDocumentTemplateComponent implements OnInit {
    errorTitle: string = environment.config.customNotifications.headers.error;
    errorIcon: string = environment.config.customNotifications.icons.error;
    errorType: string = environment.config.customNotifications.icons.error;
    helper = helper;
    document_generabil_dual: boolean = this.data.document_generabil_dual;
    is_address: boolean = this.data.is_address;
    registru_necessary: boolean = this.data.registru_necessary;

    token!: string;
    isLoading = false;

    destination: string = 'toPrimarie';

    form: FormGroup = new FormGroup({
        name: new FormControl(this.data.name, [Validators.required]),
        context: new FormControl(this.data.context, [Validators.required]),
        context_cetatean: new FormControl(this.data.context_cetatean),
        is_address: new FormControl(this.data.is_address),
        type_id: new FormControl(this.data.type_id, [Validators.required]),
        registru_id: new FormControl(this.data.registru_id),
        registru_necessary: new FormControl(this.data.registru_necessary),
        document_generabil_dual: new FormControl(this.data.document_generabil_dual),
        destination: new FormControl(this.destination),
    }, { validators: conditionalRequiredValidator('registru_id', 'registru_necessary', true) });

    cereriTypes$: any = [];
    registre$: any = [];

    defaultParameter: { name: string; id: string } = {
        name: '--Alegeți--',
        id: '-1',
    };

    editorConfig!: AngularEditorConfig;

    constructor(
        @Inject(MAT_DIALOG_DATA)
        public data: any,
        private dialogRef: MatDialogRef<EditDocumentTemplateComponent>,
        private componentService: ComponentService,
        private notificationService: NotificationService,
        private authService: AuthService,
        private documentCategoryService: DocumentCategoryService,
        private cerereTypeService: CerereTypeService,
        private registreService: RegistreService
    ) {
        this.processToken();
        console.log(this.data);
    }

    ngOnInit(): void {
        this.editorConfig = initializeEditor();
        this.loadDocumentCereriTypes();
        this.loadDocumentRegistre();
    }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }

    processToken() {
        const tokenObj = this.authService.returnTokenUser();
        tokenObj.then((token) => {
            this.token = token;
            this.componentService.setToken(token);
        });
    }

    onDestinatieChange(option: any) {

        this.destination = option.value;

        const contextTouchedOrDirty =
            this.form.get('context')?.touched || this.form.get('context')?.dirty;
        const contextCetateanTouchedOrDirty =
            this.form.get('context_cetatean')?.touched ||
            this.form.get('context_cetatean')?.dirty;
        const contextHasValue = this.form.get('context')?.value.length > 0;
        const contextCetateanHasValue =
            this.form.get('context_cetatean')?.value.length > 0;

        const shouldConfirmClear =
            (contextTouchedOrDirty && contextHasValue) ||
            (contextCetateanTouchedOrDirty && contextCetateanHasValue);

        const clearContent = () => {
            const patchValues: any = {};
            if (
                option.value === 'toCetatean' &&
                contextCetateanTouchedOrDirty &&
                contextCetateanHasValue
            ) {
                patchValues.context_cetatean = '';
            } else if (
                option.value === 'toPrimarie' &&
                contextTouchedOrDirty &&
                contextHasValue
            ) {
                patchValues.context = '';
            } else if (option.value === 'toate') {
                if (contextTouchedOrDirty && contextHasValue) {
                    patchValues.context = '';
                }
                if (contextCetateanTouchedOrDirty && contextCetateanHasValue) {
                    patchValues.context_cetatean = '';
                }
            }

            this.form.patchValue(patchValues);
            this.destination = option.value;
        };

        // we decide here later on the road
        // if (shouldConfirmClear) {
        //     Swal.fire({
        //         title: 'Sunteți sigur?',
        //         text: 'Această acțiune vă șterge conținutul adăugat până la acest moment.',
        //         icon: 'warning',
        //         showCancelButton: true,
        //         confirmButtonColor: '#3085d6',
        //         cancelButtonColor: '#d33',
        //         confirmButtonText: 'Da, șterge!',
        //     }).then((result) => {
        //         if (result.isConfirmed) {
        //             clearContent();
        //             Swal.fire('Șters!', 'Conținutul a fost șters.', 'success');
        //         }
        //     });
        // } else {
        // }
    }
    onAdresaChange(option: any) {
        this.form.get('is_address')?.setValue(option.value);
    }

    onRegistruChange(option: any) {
        this.form.get('registru_necessary')?.setValue(option.value);
        this.form.patchValue({
            registru_id: option.value == false ? '' : this.form.value.registru_id,
            registru_necessary: option.value
        })
    }

    onDualChange(option: any) {
        this.form.get('document_generabil_dual')?.setValue(option.value);
        this.form.patchValue({
            destination: option.value == false ? 'toPrimarie' : this.form.value.destination,
            document_generabil_dual: option.value
        })
        if (option.value == false) {
            this.destination = 'toPrimarie';
        }
    }

    submitForm() {
        this.isLoading = true;

        const {
            name,
            context,
            is_address,
            context_cetatean,
            type_id,
            registru_id,
            registru_necessary,
            document_generabil_dual,
        } = this.form.value as objectPayload;
        const updateObj: objectEditPayload = {
            id: this.data.id,
            type_id,
            name,
            context,
            is_address,
            context_cetatean,
            registru_id,
            registru_necessary,
            document_generabil_dual,
        };

        this.componentService
            .update(updateObj)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: () => {
                    this.dialogRef.close({ success: true });
                },
                error: (err) => {
                    let msg;
                    try {
                        // try to catch the message from server
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        // controll output message
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        helper.dialogConfig.headers.errorAtentie,
                        msg,
                        this.errorIcon
                    );
                },
            });
    }

    onHttpError(res: any) {
        if (res.errors && res.errors.message && res.errors.message.length > 0) {
            res.errors.message.forEach((msg: string) => {
                this.notificationService.warningSwal(
                    this.errorTitle,
                    msg,
                    this.errorIcon
                );
            });
        } else {
            let msg;
            try {
                // try to catch the message from server
                msg = res.error.errors.message[0];
            } catch (error) {
                // controll output message
                msg = helper.dialogConfig.generalMessages.error;
            }
            this.notificationService.warningSwal(
                this.errorTitle,
                msg,
                this.errorIcon
            );
        }
    }

    loadDocumentCereriTypes() {
        this.isLoading = true;
        this.cereriTypes$ = this.cerereTypeService.getRecordsList().pipe(
            map((results: any) => [this.defaultParameter, ...results]),
            finalize(() => (this.isLoading = false))
        );
    }

    loadDocumentRegistre() {
        this.isLoading = true;
        this.registre$ = this.registreService.getRecordsList().pipe(
            map((results: any) => [this.defaultParameter, ...results]),
            finalize(() => (this.isLoading = false))
        );
    }
}
